import { gql } from '@apollo/client';

import { useQuery } from '@fhs/client';
import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { client } from '@fhs-legacy/frontend/src/state/graphql/client';

import {
  GetGiftCardTransactionHistoryInput,
  GetGiftCardTransactionHistoryPayload,
} from '../utils/types';

const GetGiftCardTransactionHistoryQuery = gql`
  query GetGiftCardTransactionHistory($input: GetGiftCardTransactionHistoryInput)
  @gateway
  @authRequired {
    getGiftCardTransactionHistory(input: $input) {
      giftCard {
        transactions {
          date
          type
          amount
        }
      }
    }
  }
`;

export const useGetGiftCardTransactionHistoryQuery = ({
  token,
  expiryDate,
  enabled = true,
}: GetGiftCardTransactionHistoryInput & { enabled?: boolean }) => {
  const { user } = useAuthContext();

  return useQuery({
    enabled,
    queryKey: ['getGiftCardTransactionHistory', user?.cognitoId, token, expiryDate],
    queryFn: async () => {
      const { data } = await client.query({
        query: GetGiftCardTransactionHistoryQuery,
        variables: {
          input: {
            token,
            expiryDate,
          },
        },
        fetchPolicy: 'network-only',
      });
      return data?.getGiftCardTransactionHistory?.giftCard as GetGiftCardTransactionHistoryPayload;
    },
  });
};
